import { Component, CUSTOM_ELEMENTS_SCHEMA, NgModule, ElementRef, ViewChild, Input, ChangeDetectorRef, HostListener } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { ViewController, PopoverController } from 'ionic-angular';
import { Events } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { EncrDecrServiceProvider } from '../../providers/encr-decr-service/encr-decr-service';
import { ConfigApiServiceProvider } from '../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../providers/configure-service/configure-service';
import { DriveServiceProvider } from '../../providers/drive-service/drive-service';
import { ContactManagerProvider } from '../../providers/contact-manager/contact-manager';


@NgModule({
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

@Component({
  selector: 'page-scheduler',
  templateUrl: 'scheduler.html',
})

export class SchedulerPage {
  @Input() params: any;
  public items: any = [];
  ID: any;
  E_mail: boolean = false;
  accordian_tab1: boolean = false;
  accordian_tab2: boolean = false;
  accordian_tab3: boolean = false;
  allowDocuSign: boolean = false;
  showShareAccessPopup: any = false;
  shareDataSet: any;
  selectedRowData: any = {};
  loginUserName: any = '';
  mailDataLink: any = '';
  showBcc: boolean = false;
  showCc: boolean = false;
  showTo: boolean = false;
  ShareID: any;
  currentSelectedTo: any;
  currentSelectedCc: any;
  currentSelectedBcc: any;
  bccSelectedFolder: any = "";
  ccSelectedFolder: any = "";
  toSelectedFolder: any = "";
  addedFile: any;
  list: any = [];
  mailId: any = [];
  mailIdBcc: any = [];
  mailIdCc: any = [];
  folder: any;
  mailData: any;
  tempData: any;
  tempName: string;
  height: any = 75;

  submitData: string;
  fieldValues: any = {
    "From": "",
    "To": "",
    "Cc": "",
    "Bcc": "",
    "Subject": "",
    "Body": "",
  }
  nameData: any;
  toMail: any = [];
  newToMail: any = [];
  newCcMail: any = [];
  bccData: any;
  ccData: any;
  bccMail: any = [];
  ccMail: any = [];
  newBccMail: any = [];
  fieldData: any;
  EmailID: any = [];

  mailSubject: any;
  email_list: any = [];
  mailFolderId: any = {};
  date: any;
  objCurrentFolderProperties: any;
  arrListContactFolder: any = [];
  istoItemAvailable = false;
  isbccItemAvailable = false;
  isccItemAvailable = false;
  arrListContact: any = [];
  itemsto = [];
  itemsbcc = [];
  itemscc = [];

  mailScheduler: any = { 'TOID': '', "CC": "", "BCC": "", "FROMID": "", "SUBJECT": "", "BODY": "", "ShareID": "" }
  @ViewChild('emailElement', { 'static': false }) emailElement: ElementRef;
  @ViewChild('insideElement', { 'static': false }) insideElement: ElementRef;
  @ViewChild('TOID', { 'static': false }) TOID: ElementRef;
  @ViewChild('CC', { 'static': false }) CC: ElementRef;
  @ViewChild('SUBJECT', { 'static': false }) SUBJECT: ElementRef;
  @ViewChild('BCC', { 'static': false }) BCC: ElementRef;
  @ViewChild('FROMID', { 'static': false }) FROMID: ElementRef;
  @ViewChild('accessTypeName', { 'static': false }) accessTypeName: ElementRef;
  @ViewChild('BODY', { 'static': false }) BODY: ElementRef;
  shareData: any = { 'text': 'Anyone with the link can view', id: '1' }


  constructor(public toastMessage: ToastController, public cdr: ChangeDetectorRef, public encrDecrService: EncrDecrServiceProvider, public popoverController: PopoverController, public driveService: DriveServiceProvider, public configureService: ConfigureServiceProvider, public element: ElementRef, public configApiService: ConfigApiServiceProvider, public navCtrl: NavController, public events: Events, public navParams: NavParams, public viewCtrlScheduler: ViewController, private modal: ModalController, public contactManager: ContactManagerProvider) {
    // var el = this.element.nativeElement;
  }

  ngOnInit() {
    this.selectedRowData = this.navParams.get('selectedRowData');
    this.shareDataSet = this.navParams.get('shareDataSet');
    // this.mailDataLink = this.navParams.get('dataLink');
    this.ShareID = this.navParams.get('ShareID');
    this.loginUserName = this.configureService.getLoginData()["user"];
    this.mailScheduler.Subject = this.loginUserName + " has shared an information to you.";
    this.objCurrentFolderProperties = this.navParams.get('objCurrentFolderProperties');

    this.arrListContactFolder = this.contactManager.getContactFolders();
    this.toSelectedFolder = this.contactManager.getSelectedFolders(this.fieldValues.mailFolderId, 'to');
    this.bccSelectedFolder = this.contactManager.getSelectedFolders(this.fieldValues.mailFolderId, 'bcc');
    this.ccSelectedFolder = this.contactManager.getSelectedFolders(this.fieldValues.mailFolderId, 'cc');
  }

  showmail() {
    if (this.E_mail == false) {
      this.E_mail = true;
      this.ID = true;
      this.events.publish('ID', this.ID);
    } else {
      this.E_mail = false;
      this.ID = false;
      this.events.publish('ID', this.ID);
    }
  }

  divNum = new Array("tab-1", "tab-2", "tab-3");

  close_accordian(theID) {
    for (var i = 0; i < this.divNum.length; i++) {
      if (this.divNum[i] == theID) {
        if (document.getElementById(this.divNum[i]).style.display == "block") {
          document.getElementById(this.divNum[i]).style.display = "none"
        }
        else { document.getElementById(this.divNum[i]).style.display = "block" }
      }
      else { document.getElementById(this.divNum[i]).style.display = "none"; }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SchedulerPage');
  }

  closeScheduler() {
    this.viewCtrlScheduler.dismiss();
  }

  on_close() {
    this.viewCtrlScheduler.dismiss();
  }

  sendMail() {
    console.log(this.toSelectedFolder, this.bccSelectedFolder, this.ccSelectedFolder, this.mailSubject, this.date);
    if (this.toSelectedFolder != "" || this.toSelectedFolder != undefined) {
      for (let i = 0; i < this.toSelectedFolder.length; i++) {
        this.nameData = this.toSelectedFolder[i];
        this.toMail.push(this.mailId[this.nameData]);
      }
      for (let i = 0; i < this.toMail.length; i++) {
        this.newToMail = this.newToMail.concat(this.toMail[i]);
      }
    }
    console.log(this.newToMail)
    if (this.bccSelectedFolder != "" || this.bccSelectedFolder != undefined) {
      for (let i = 0; i < this.bccSelectedFolder.length; i++) {
        this.bccData = this.bccSelectedFolder[i];
        this.bccMail.push(this.mailIdBcc[this.bccData]);
      }
      for (let i = 0; i < this.bccMail.length; i++) {
        this.newBccMail = this.newBccMail.concat(this.bccMail[i]);
      }
    }
    console.log(this.newBccMail);
    if (this.ccSelectedFolder != "" || this.ccSelectedFolder != undefined) {
      for (let i = 0; i < this.ccSelectedFolder.length; i++) {
        this.ccData = this.ccSelectedFolder[i];
        this.ccMail.push(this.mailIdCc[this.ccData]);
      }
      for (let i = 0; i < this.ccMail.length; i++) {
        this.newCcMail = this.newCcMail.concat(this.ccMail[i]);
      }
    }
    console.log(this.newCcMail);

    this.fieldValues["From"] = this.loginUserName,
      this.fieldValues["To"] = this.newToMail,
      this.fieldValues["Cc"] = this.newCcMail,
      this.fieldValues["Bcc"] = this.newBccMail;
    this.fieldValues["Subject"] = this.SUBJECT.nativeElement.value || '';
    this.fieldValues["Body"] = this.BODY.nativeElement.value || '';

    if (this.allowDocuSign) {
      this.viewCtrlScheduler.dismiss();
      let signerName = ''
      let signerEmail = (this.fieldValues["To"].length > 0 ? this.fieldValues["To"] : ['raj.thulasidoss@starport.ca'])
      let ccName = ''
      let ccEmail = (this.fieldValues["Cc"].length > 0 ? this.fieldValues["Cc"] : this.loginUserName);
      let subject = this.fieldValues["Subject"]
      let body = this.fieldValues["Body"]
      let documentPathArr: any = [];

      if (this.selectedRowData.length > 0) {
        for (let rowData of this.selectedRowData) {
          if (rowData['attachments']) {
            documentPathArr.push(rowData['attachments']);
          }
        }
      }

      //let query = 'signerName=' + signerName + '&signerEmail=' + signerEmail + '&ccName=' + ccName + '&ccEmail=' + ccEmail + '&subject=' + subject + '&body=' + body + '&documentPath=' + documentPathArr;
      //let url = 'https://time.starport.ca:62222/eg002?' + query;
      //let url = 'http://localhost:5000/eg002?' + query;

      if (documentPathArr.length > 0) {
        var url = "https://time.starport.ca:62224/docusign/send";
        // var url =  "http://localhost:5000/docusign/send";
        let objData = {
          name: signerName,
          email: signerEmail,
          subject: subject || 'this is dosusign Subject',
          body: body || "",
          document: documentPathArr
        }
        this.configApiService.customRequest(url, objData, this.docusignMaillSucess)
      } else {
        const toast = this.toastMessage.create({
          message: 'Attachments is missing !!',
          duration: 2000
        });
        toast.present();
      }

    } else {
      // this.shareData.id == "1" ? this.shareDataSet['SharedInfo']['accessType'] = 'public' : this.shareDataSet['SharedInfo']['accessType'] = 'private';
      // this.shareDataSet['SharedInfo']['recipientMailId'] = this.fieldValues["To"];
      // this.configApiService.pushRequest(this.shareDataSet, this.mailSendProcessing);
      this.mailSendProcessing();
    }
  }

  docusignMaillSucess = ((responsedata) => {
    console.log("docusignMaillSucess", responsedata);
    let message = '';
    if (responsedata.response === 'success') {
      message = "Docusign mail has been send !!"
    } else {
      message = "Error creating Docusign mail !!"
    }
    const toast = this.toastMessage.create({
      message: message,
      duration: 2000
    });
    toast.present();
  });

  mailSendProcessing() {
    // console.log(responsedata);
    // let generateUrl: any = window.location.origin + '/?ShareID=' + responsedata["ShareID"] + '&studio=' + this.configureService.getStudio() + '&userid=' + this.configureService.getLoginUserID();
    // this.mailDataLink = generateUrl;
    let data = {};
    // console.log('url ', generateUrl);
    let body = this.convertHtml(this.BODY.nativeElement.value);
    this.mailScheduler = { 'TOID': this.fieldValues["To"], 'CC': this.CC != undefined ? this.fieldValues["Cc"] : '', 'BCC': this.BCC != undefined ? this.fieldValues["Bcc"] : '', 'FROMID': this.loginUserName, 'BODY': body, 'ShareID': this.ShareID, 'SUBJECT': this.SUBJECT };
    data = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params, this.mailScheduler);
    this.configApiService.pushRequest(data, this.mailSentResponseStatus);
  }

  mailSentResponseStatus = ((responsedata) => {
    console.log('Mail Status ', responsedata);
    this.viewCtrlScheduler.dismiss();

    var message = this.toastMessage.create({
      message: 'Mail Sent Successfully',
      duration: 2000
    });
    message.present();
    // var modalPage = this.modal.create(CopyLinkPopupComponent, { 'urlLink': this.mailDataLink }, { cssClass: "copySentMail" });
    // modalPage.present();
    // modalPage.onDidDismiss(data => {
    // });
  });

  showAccess(e) {
    if (this.showShareAccessPopup == true) {
      this.showShareAccessPopup = false;
    } else if (this.showShareAccessPopup == false) {
      this.showShareAccessPopup = true;
    }
  }

  dataSet(ev) {
    this.shareData = ev;
    if (ev.id) {
      this.showShareAccessPopup = false;

    } else {
      let data = {};
      let body = this.convertHtml(this.BODY.nativeElement.value);
      this.mailScheduler = { 'TOID': this.TOID.nativeElement.innerText, 'CC': this.CC != undefined ? this.CC.nativeElement.innerText : '', 'BCC': this.BCC != undefined ? this.BCC.nativeElement.innerText : '', 'FROMID': this.loginUserName, 'BODY': body, 'ShareID': this.ShareID };
      data = Object.assign({}, this.configApiService.driveApi.pushMailShareUser.params, this.mailScheduler);
      this.configApiService.pushRequest(data, (responseData) => {
        console.log('Mail Status ', responseData);
      })
    }
    this.accessTypeName.nativeElement.innerText = ev['text'];
  }

  convertHtml(text) {
    let bodyHtml: any = '';
    bodyHtml = '<div><p>' + this.BODY.nativeElement.value.replace(/\r\n|\r|\n/g, "</p><br /><p>") + '</p></div><div style="text-align:center"></div>';
    return bodyHtml;
  }

  validateEmail(email) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(email) == false) {
      return false;
    }
    return true;
  }

  // @HostListener('document:click', ['$event.target'])
  // public onClick(targetElement) {
  //   const clickedInside = this.insideElement.nativeElement.contains(targetElement);
  //   if (!clickedInside) {
  //     console.log('outside clicked');
  //     // if (emailElem.inputText) {
  //     //   this.currentSelectedTo = "TO";
  //     //   let mailArr: any = [];
  //     //   let data = { 'display': emailElem.inputText.replace(/[ ,]+/g, ""), 'value': emailElem.inputText.replace(/[ ,]+/g, "") }
  //     //   mailArr.push(data);
  //     //   this.toSelectedFolder = mailArr;
  //     //   this.onGetResults(mailArr);
  //     //   emailElem.inputText = '';
  //     //}
  //   }
  // }


  focusout(event, type) {
    console.log("focus", event);
    if (event.target['value'] != '') {
      let obj = {};
      obj['display'] = event.target['value'].replace(/[ ,]+/g, "");
      obj['value'] = event.target['value'].replace(/[ ,]+/g, "");

      if (type === 'to') {
        this.toSelectedFolder.push(obj['value']);
        this.mailId[obj['display']] = obj['display'];
        this.istoItemAvailable = false;
      } else if (type === 'cc') {
        this.ccSelectedFolder.push(obj['value']);
        this.mailIdCc[obj['display']] = obj['display'];
        this.isccItemAvailable = false;
      } else if (type === 'bcc') {
        this.bccSelectedFolder.push(obj['value']);
        this.mailIdBcc[obj['display']] = obj['display'];
        this.isbccItemAvailable = false;
      }
      event.target['value'] = '';
    }
  }

  initializeItems() {
    this.arrListContactFolder = this.contactManager.getContactFolders();
  }

  getItems(ev: any, key) {
    // Reset items back to all of the items
    this.initializeItems();

    // set val to the value of the searchbar
    const val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      if (key == 'to') {
        this.istoItemAvailable = true;
      }
      if (key == 'bcc') {
        this.isbccItemAvailable = true;
      }
      if (key == 'cc') {
        this.isccItemAvailable = true;
      }
      this.arrListContactFolder = this.arrListContactFolder.filter((item) => {
        return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })

    } else {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
      this.itemsto = [];
      this.itemsbcc = [];
      this.itemscc = [];
    }
  }

  onKey(event: KeyboardEvent, key) {
    console.log(event);
    // 32 space,188 comma,32 Tab
    if (key == 'to') {
      this.getItems(event, key);
    }
    if (key == 'cc') {
      console.log(event);
      // 32 space,188 comma,32 Tab
      this.getItems(event, key);
    }
    if (key == 'bcc') {
      this.getItems(event, key);
    }

  }
  onSelect(item) {
    console.log('tag selected: value is ' + item);
  }
  onChange(e) {
    console.log("eleme", e);
  }

  onItemAddedTo(e) {
    let isMail = this.validateEmail(e.display)
    this.currentSelectedTo = (isMail === true ? "TO" : e.display);
    let mail = [e];
    mail.push({ mail: 'to' })
    this.onItemAdded(mail);
  }

  onItemAddedCc(e) {
    this.currentSelectedCc = e.display;
    let mail = [e];
    mail.push({ mail: 'cc' });
    this.onItemAdded(mail);
  }

  onItemAddedBcc(e) {
    this.currentSelectedBcc = e.display;
    let mail = [e];
    mail.push({ mail: 'bcc' });
    this.onItemAdded(mail);
  }

  onItemRemovedTo(e) {
    console.log("data", e)
    delete this.mailId[e.display];
    console.log(this.mailId);
  }

  onItemRemovedCc(e) {
    console.log("data", e)
    delete this.mailIdCc[e.display];
    console.log(this.mailIdCc);
  }

  onItemRemovedBcc(e) {
    console.log("data", e);
    delete this.mailIdBcc[e.display];
    console.log(this.mailIdBcc);
  }

  onItemAdded(e) {
    this.addedFile = e[0].value;
    for (let i = 0; i < this.folder[0].folders.length; i++) {
      if (this.folder[0].folders[i].name == this.addedFile) {
        // this.pullData = this.folder[0].folders[i].template[0].pullParams;
        this.tempData = this.folder[0].folders[i];
        console.log(this.tempData)
      }
    }
    this.onGetResults(e);
    console.log(e);
  }

  getMailList(e, type) {
    this.contactManager.getMailList(e, (email) => {
      if (type == "to") {
        this.mailId[e['name']] = email;
      } else if (type == "cc") {
        this.ccMail[e['name']] = email;
      } else if (type == "bcc") {
        this.bccMail[e['name']] = email;
      }
      if (!this.mailFolderId[type]) {
        this.mailFolderId[type] = e.folder_id;
      } else {
        this.mailFolderId[type] = this.mailFolderId[type] + ',' + e.folder_id;
      }
    });
  }

  openContactFolders(ev, key) {
    if (key == "to") {
      this.istoItemAvailable = true;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    } else if (key == "bcc") {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = true;
      this.isccItemAvailable = false;
    } else if (key == "cc") {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = true;
    }
  }

  onInputFocused(e, key) {
    this.initializeItems();
    if (key == 'to') {
      this.istoItemAvailable = true;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    }
    if (key == 'bcc') {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = true;
      this.isccItemAvailable = false;
    }
    if (key == 'cc') {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = true;
    }

  }

  onInputBlur(e, key) {
    if (key == 'to') {

    }
    if (key == 'bcc') {

    }
    if (key == 'cc') {

    }
  }
  @ViewChild('userinputTo', { 'static': false }) userinputTo: ElementRef;
  @ViewChild('userinputCc', { 'static': false }) userinputCc: ElementRef;
  @ViewChild('userinputBcc', { 'static': false }) userinputBcc: ElementRef;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickedElementTo = this.userinputTo.nativeElement.contains(targetElement);
    const clickedElementCc = this.userinputTo.nativeElement.contains(targetElement);
    const clickedElementBcc = this.userinputTo.nativeElement.contains(targetElement);
    if (!clickedElementTo || !clickedElementCc || !clickedElementBcc) {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    } else {
      if (clickedElementTo) {
        this.istoItemAvailable = true;
        this.isbccItemAvailable = false;
        this.isccItemAvailable = false;
      } else if (clickedElementCc) {
        this.istoItemAvailable = false;
        this.isbccItemAvailable = false;
        this.isccItemAvailable = true;
      } else if (clickedElementBcc) {
        this.istoItemAvailable = false;
        this.isbccItemAvailable = false;
        this.isccItemAvailable = true;
      }
    }
  }
  public onAddto(item) {
    console.log('tag added: value is ' + item);
    if (this.toSelectedFolder.length == 0) {
      if (item.value != '') {
        this.toSelectedFolder.push(item.value);
        this.getMailList(item.display, 'to');
      }
    } else {
      let index: any = this.toSelectedFolder.findIndex(element => element == item.value);
      if (index == -1) {
        if (item.value != '') {
          this.toSelectedFolder.push(item.value);
          this.getMailList(item.display, 'to');
        }
      } else if (index >= 0) {
        this.toSelectedFolder.splice(index, 1);

        if (item.value != '') {
          this.toSelectedFolder.push(item.value);
          // this.getMailList(item.display,'to');
        }
      }
    }
  }

  public onAddcc(item) {
    console.log('tag added: value is ' + item);
    if (this.ccSelectedFolder.length == 0) {
      if (item.value != '') {
        this.ccSelectedFolder.push(item.value);
        this.getMailList(item.display, 'cc');
      }
    } else {
      let index: any = this.ccSelectedFolder.findIndex(element => element == item.value);
      if (index == -1) {
        if (item.value != '') {
          this.ccSelectedFolder.push(item.value);
          this.getMailList(item.display, 'cc');
        }
      } else if (index >= 0) {
        this.ccSelectedFolder.splice(index, 1);
        if (item.value != '') {
          this.ccSelectedFolder.push(item.value);
        }
      }
    }
  }

  public onAddbcc(item) {
    console.log('tag added: value is ' + item);
    if (this.bccSelectedFolder.length == 0) {
      if (item.value != '') {
        this.bccSelectedFolder.push(item.value);
        this.getMailList(item.display, 'bcc');
      }
    } else {
      let index: any = this.bccSelectedFolder.findIndex(element => element == item.value);
      if (index == -1) {
        if (item.value != '') {
          this.bccSelectedFolder.push(item.value);
          this.getMailList(item.display, 'bcc');
        }
      } else if (index >= 0) {
        this.bccSelectedFolder.splice(index, 1);
        if (item.value != '') {
          this.bccSelectedFolder.push(item.value);
        }
      }
    }
  }

  addDropdown(e, key) {
    if (key == 'to') {
      this.onAddto({ 'display': e, 'value': e.name.replace(/[ ,]+/g, "") });
      (<HTMLInputElement>document.querySelectorAll('#toMail')[0].children[1]).value = '';
    }
    if (key == 'cc') {
      this.onAddcc({ 'display': e, 'value': e.name.replace(/[ ,]+/g, "") });
      (<HTMLInputElement>document.querySelectorAll('#ccMail')[0].children[1]).value = '';
    }
    if (key == 'bcc') {
      this.onAddbcc({ 'display': e, 'value': e.name.replace(/[ ,]+/g, "") });
      (<HTMLInputElement>document.querySelectorAll('#bccMail')[0].children[1]).value = '';
    }

    this.istoItemAvailable = false;
    this.isbccItemAvailable = false;
    this.isccItemAvailable = false;
    this.itemsto = [];
    this.itemsbcc = [];
    this.itemscc = [];
  }

  onGetResults(e) {
    if (this.currentSelectedTo === "TO") {
      this.mailId[e[0].display] = e[0].display;
    } else {
      this.mailData = e[1].mail;
      let data = Object.assign({}, this.tempData);
      this.configApiService.pullRequest(data, this.submitSummerySucess)
    }
  }

  submitSummerySucess = ((fieldData) => {
    if (this.mailData == "to") {
      let mail = [];
      for (let j = 0; j < fieldData.length; j++) {
        if (fieldData[j].EMail) {
          mail.push(fieldData[j].EMail);
        }
      }
      this.mailId[this.currentSelectedTo] = mail;
      console.log(this.mailId)
    } else if (this.mailData == "cc") {
      let mail = [];
      for (let j = 0; j < fieldData.length; j++) {
        if (fieldData[j].EMail) {
          mail.push(fieldData[j].EMail);
        }
      }
      this.mailIdCc[this.currentSelectedCc] = mail;
      console.log(this.mailIdCc)
    } else if (this.mailData == "bcc") {
      let mail = [];
      for (let j = 0; j < fieldData.length; j++) {
        if (fieldData[j].EMail) {
          mail.push(fieldData[j].EMail);
        }
      }
      this.mailIdBcc[this.currentSelectedBcc] = mail;
      console.log(this.mailIdBcc)
    }
  });

  onShowBcc() {
    if (this.showBcc == true) {
      this.showBcc = false;
    } else {
      this.showBcc = true;
    }
    if (this.showBcc && this.showCc == true) {
      this.height = 63;
    } else if (this.showBcc == true || this.showCc == true) {
      this.height = 69;
    } else {
      this.height = 75;
    }
    this.isbccItemAvailable = true;
  }

  onShowCc() {
    if (this.showCc == true) {
      this.showCc = false;
    } else {
      this.showCc = true;
    }
    if (this.showBcc && this.showCc == true) {
      this.height = 63;
    } else if (this.showBcc == true || this.showCc == true) {
      this.height = 69;
    } else {
      this.height = 75;
    }
    this.isccItemAvailable = true;
  }

  onMail() {
    this.istoItemAvailable = true;
  }

  /*loadChildWindow(url) {
    var w = 1100;
    var h = 600;
    var left = (window.screen.width / 2) - ((w / 2) + 10);
    var top = (window.screen.height / 2) - ((h / 2) + 50);
    window.open(url, 'Popup', "status=no,height=" + h + ",width=" + w + ",resizable=yes,left=" + left + ",top=" + top + ",screenX=" + left + ",screenY=" + top + ",directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no");
  }*/

  ngAfterViewInit() {
    this.showTo = true;
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/pages/scheduler/scheduler.ts